import React, { useEffect } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { PainSection } from './components/PainSection';
import { SystemSection } from './components/SystemSection';
import { Modules } from './components/Modules';
import { LookInside } from './components/LookInside';
import { BonusSection } from './components/BonusSection';
import { ChangeSection } from './components/ChangeSection';
import { Testimonials } from './components/Testimonials';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & typeof globalThis & {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
};
const PIXEL_ID = '1514141532886290';
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    const pixelWindow = window as PixelWindow;
    try {
      if (!pixelWindow.fbq) {
        const fbq = ((...args: unknown[]) => {
          if (fbq.callMethod) {
            fbq.callMethod(...args);
          } else {
            fbq.queue?.push(args);
          }
        }) as PixelFunction;
        pixelWindow.fbq = fbq;
        if (!pixelWindow._fbq) pixelWindow._fbq = fbq;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript?.parentNode) {
          firstScript.parentNode.insertBefore(script, firstScript);
        } else {
          document.head.appendChild(script);
        }
      }
      pixelWindow.fbq?.('init', PIXEL_ID);
      pixelWindow.fbq?.('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="83i23gnmdsrt">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="3gle9ehqxh1en" />
      </noscript>
      <div className="min-h-screen w-full overflow-x-hidden bg-white text-ev-black" data-id="element-2" data-mp="3qbppt3rst32f">
        {showPurchasePopup && <PurchasePopup data-id="element-3" data-mp="3lk7lq6uhamd8" />}
        <main data-id="element-4" data-mp="3liwjibgolmo8">
          <Hero data-id="element-5" data-mp="3lj6bg4lae3wk" />
          <ProblemSection data-id="element-6" data-mp="3limr6h85z3fd" />
          <PainSection data-id="element-7" data-mp="2xud99qe2mzti" />
          <SystemSection data-id="element-8" data-mp="2xtlrbided0lp" />
          <Modules data-id="element-9" data-mp="2xt253pgprq1v" />
          <LookInside data-id="element-10" data-mp="2svto3s7axs27" />
          <BonusSection data-id="element-11" data-mp="2swbtpffutims" />
          <ChangeSection data-id="element-12" data-mp="2sv0odb6rg2tk" />
          <PricingCard data-id="element-13" data-mp="2stpmjgwvl553" />
          <Guarantee data-id="element-14" data-mp="18drk5y5ejjev" />
          <Testimonials data-id="element-15" data-mp="18dhr21p28w4y" />
          <FAQ data-id="element-16" data-mp="18czpcpjmpppn" />
          <FinalCTA data-id="element-17" data-mp="18cggdybyibnr" />
        </main>
        <Footer data-id="element-18" data-mp="1d47x7h5b930p" />
      </div>
    </>;
}